
import React from 'react';
import { passengerDisplayName } from "../lib/filters";
import { Flight, Leg, Trip } from '../../js/headersegment/interfaces';

interface Passenger {
  firstName?: string;
  lastName?: string;
}

interface TripsListItemProps {
  trips: Trip[];
}

const TripsListItem: React.FC<TripsListItemProps> = ({ trips }) => {
  const passengerDisplayNameFilter = (passenger: Passenger) => passengerDisplayName(passenger);

  const renderRows = (trips: Trip[]) => {
    const timerName = '[tripsListItem] Render performance';
    console.time(timerName);
    
    let numOfIssuesTxt: string;

    let tripTable = trips.map((trip: any, i: number) => {
      let recordLocator = trip.recordLocator;
      if (trip.recordLocator.length > 15) {
        recordLocator = recordLocator.substring(0, 12) + '...';
      }

      const cells: JSX.Element[] = [];

      if (trip.totalIssues === 0) {
        cells.push(
          <td key={`recordLocator-${i}`}>
            <a className="record-locator-base" href={`/trip/${trip.id}`} title={trip.recordLocator}>{recordLocator}</a>
          </td>
        );
      } else if (trip.totalIssues > 0 && trip.totalIssues < 10) {
        numOfIssuesTxt = trip.totalIssues === 1 ? '1 Issue' : `${trip.totalIssues} Issues`;
        cells.push(
          <td key={`recordLocator-${i}`}>
            <a href={`/trip/${trip.id}`}>
              <div className="record-locator-base record-locator" title={trip.recordLocator}>{recordLocator}</div>
              <div title={numOfIssuesTxt} className={`record-locator-issues num-of-issues-icon sprites sprite-issues-gray-${trip.totalIssues}-16`}></div>
            </a>
          </td>
        );
      } else {
        numOfIssuesTxt = '10+ Issues';
        cells.push(
          <td key={`recordLocator-${i}`}>
            <a href={`/trip/${trip.id}`}>
              <div className="record-locator-base record-locator" title={trip.recordLocator}>{recordLocator}</div>
              <div title={numOfIssuesTxt} className={`record-locator-issues num-of-issues-icon sprites sprite-issues-gray-many-16`}></div>
            </a>
          </td>
        );
      }

      cells.push(
        <td key={`groupName-${i}`}>
          <span>{trip.groupName}</span>
        </td>
      );

      const passengers = trip.passengers.map((passenger: any, j: any) => (
        <div key={`passenger-${i}-${j}`}>
          {passengerDisplayNameFilter(passenger)}
        </div>
      ));
      cells.push(<td key={`passengers-${i}`}>{passengers}</td>);

      const emails = trip.emailAddresses.map((email: any, j: number) => (
        <div key={`email-${i}-${j}`}>{email}</div>
      ));
      cells.push(<td key={`emails-${i}`}>{emails}</td>);

      const flightNumCells: JSX.Element[] = [];
      const flightDateCells: JSX.Element[] = [];
      const flightDepTimeCells: JSX.Element[] = [];
      const flightArrTimeCells: JSX.Element[] = [];
      const flightAirportsCells: JSX.Element[] = [];

      trip.legs.forEach((leg: Leg, j: number) => {
        leg.flights.forEach((flight: Flight, k: number) => {
          const classes = k + 1 === leg.flights.length && j + 1 < trip.legs.length ? 'single-line separator' : 'single-line';
          flightNumCells.push(
            <div key={`flightNum-${i}-${j}-${k}`} className={classes}>
              {flight.airline?.code} {flight.number}
            </div>
          );
          flightDateCells.push(
            <div key={`flightDate-${i}-${j}-${k}`} className={classes}>
              {flight?.departureTimeDMY}
            </div>
          );
          flightDepTimeCells.push(
            <div key={`flightDepTime-${i}-${j}-${k}`} className={classes}>{flight.departureTime}</div>
          );
          flightArrTimeCells.push(
            <div key={`flightArrTime-${i}-${j}-${k}`} className={classes}>{flight?.arrivalTime}</div>
          );
          flightAirportsCells.push(
            <div key={`flightAirports-${i}-${j}-${k}`} className={classes}>{`${flight.departureAirportCode}-${flight.arrivalAirportCode}`}</div>
          );
        });
      });

      cells.push(<td key={`flightNum-${i}`} className="right">{flightNumCells}</td>);
      cells.push(<td key={`flightDate-${i}`} className="center">{flightDateCells}</td>);
      cells.push(<td key={`flightDepTime-${i}`} className="center">{flightDepTimeCells}</td>);
      cells.push(<td key={`flightArrTime-${i}`} className="center">{flightArrTimeCells}</td>);
      cells.push(<td key={`flightAirports-${i}`} className="left">{flightAirportsCells}</td>);

      return <tr key={`trip-${i}`}>{cells}</tr>;
    });
    console.timeEnd(timerName);
    return tripTable;
  };

  return (<>{renderRows(trips)}</>);
};

export default TripsListItem;